var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconType === 'icon')?_c('i',{class:`icon-${_vm.iconContent} vtd-icon-7`}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }